var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled, { css } from 'styled-components';
import { Color, FontWeight, BreakPoint } from '../const/index';
import Question from '../question/question';
import Icons from '../icon/icon';
import { Vertical } from '../layout/layout';
import { fadeIn } from '../mixin/animation';
import { verticalHorizontalCentering } from '../mixin/mixin';
import ScrollLock from '../feedback/scroll-lock';
import Feedback from '../feedback/feedback';
var Close = Icons.Close;
var ModalBase = (function (_super) {
    __extends(ModalBase, _super);
    function ModalBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModalBase.prototype.render = function () {
        var _a = this.props, hasHeader = _a.hasHeader, onClose = _a.onClose, title = _a.title, contentRef = _a.contentRef, children = _a.children, appearance = _a.appearance, question = _a.question, footer = _a.footer, isScrollable = _a.isScrollable;
        return (React.createElement(ModalWrapper, { appearance: appearance },
            hasHeader && (React.createElement(Header, null,
                React.createElement(StyledCloseIcon, { onClick: onClose },
                    React.createElement(Close, null)),
                React.createElement(Title, null, title),
                question && question.text && (React.createElement(Question, { text: question.text, link: question.link || '', placement: 'right', trigger: ['hover'] })))),
            React.createElement(Content, { isScrollable: isScrollable, ref: contentRef },
                children,
                React.createElement(ScrollLock, null)),
            footer && (React.createElement(Footer, null,
                React.createElement(Left, null, footer.left),
                React.createElement(Right, null, footer.right)))));
    };
    ModalBase.defaultProps = {
        appearance: 'medium',
        hasHeader: true,
        hasFooter: true,
        isScrollable: true,
    };
    return ModalBase;
}(React.Component));
var Modal = (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Modal.prototype.render = function () {
        return (React.createElement(Feedback, { onClose: this.props.onClose },
            React.createElement(ModalBase, __assign({}, this.props))));
    };
    return Modal;
}(React.Component));
export default Modal;
var getModalSize = function (props) {
    switch (props.appearance) {
        case 'medium': {
            return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        width: 800px;\n      "], ["\n        width: 800px;\n      "])));
        }
        case 'large': {
            return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        max-width: 1200px;\n        min-width: 800px;\n        width: 90%;\n      "], ["\n        max-width: 1200px;\n        min-width: 800px;\n        width: 90%;\n      "])));
        }
        default: {
            return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        width: 800px;\n      "], ["\n        width: 800px;\n      "])));
        }
    }
};
var ModalWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  animation: ", " 0.5s forwards ease-in-out;\n  background: ", ";\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  height: calc(100% - 64px);\n\n  ", "\n  ", "\n  @media (max-width: ", ") {\n    width: calc(100vw - 16px);\n  }\n"], ["\n  animation: ", " 0.5s forwards ease-in-out;\n  background: ", ";\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  height: calc(100% - 64px);\n\n  ", "\n  ", "\n  @media (max-width: ", ") {\n    width: calc(100vw - 16px);\n  }\n"])), fadeIn, Color.WHITE, verticalHorizontalCentering, function (props) { return getModalSize(props); }, BreakPoint.spMax);
var StyledCloseIcon = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var Header = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  align-items: center;\n  background: ", ";\n  border-bottom: 1px solid ", ";\n  border-radius: 8px 8px 0 0;\n  display: flex;\n  flex-shrink: 0;\n  height: 62px;\n  justify-content: center;\n  position: relative;\n\n  svg {\n    margin-left: 8px;\n  }\n\n  > ", " {\n    left: 20px;\n    position: absolute;\n    top: 20px;\n  }\n"], ["\n  align-items: center;\n  background: ", ";\n  border-bottom: 1px solid ", ";\n  border-radius: 8px 8px 0 0;\n  display: flex;\n  flex-shrink: 0;\n  height: 62px;\n  justify-content: center;\n  position: relative;\n\n  svg {\n    margin-left: 8px;\n  }\n\n  > ", " {\n    left: 20px;\n    position: absolute;\n    top: 20px;\n  }\n"])), Color.VERY_LIGHT_GRAY_4, Color.LIGHT_GRAY_2, StyledCloseIcon);
var Title = styled.h2(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 22px; /* TODO: \u4ED6\u306E\u30D6\u30E9\u30F3\u30C1\u3068\u7AF6\u5408\u3059\u308B\u306E\u3067\u3044\u3063\u305F\u3093\u3002\u3042\u3068\u3067Const\u306B\u7F6E\u304D\u63DB\u3048 */\n  font-weight: ", ";\n"], ["\n  color: ", ";\n  font-size: 22px; /* TODO: \u4ED6\u306E\u30D6\u30E9\u30F3\u30C1\u3068\u7AF6\u5408\u3059\u308B\u306E\u3067\u3044\u3063\u305F\u3093\u3002\u3042\u3068\u3067Const\u306B\u7F6E\u304D\u63DB\u3048 */\n  font-weight: ", ";\n"])), Color.VERY_DARK_GRAY, FontWeight.BOLD);
var Footer = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  background: ", ";\n  border-radius: 0 0 8px 8px;\n  border-top: 1px solid ", ";\n  box-sizing: border-box;\n  display: flex;\n  flex-shrink: 0;\n  height: 66px;\n  justify-content: space-between;\n  padding: 12px 28px;\n  position: relative;\n\n  & button {\n    margin-left: 8px;\n  }\n"], ["\n  background: ", ";\n  border-radius: 0 0 8px 8px;\n  border-top: 1px solid ", ";\n  box-sizing: border-box;\n  display: flex;\n  flex-shrink: 0;\n  height: 66px;\n  justify-content: space-between;\n  padding: 12px 28px;\n  position: relative;\n\n  & button {\n    margin-left: 8px;\n  }\n"])), Color.VERY_LIGHT_GRAY_4, Color.LIGHT_GRAY_2);
var Left = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var Right = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var Content = styled(Vertical)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  background: ", ";\n  border-radius: 8px;\n  flex: 1;\n  overflow-y: ", ";\n  padding: ", ";\n  position: relative;\n"], ["\n  background: ", ";\n  border-radius: 8px;\n  flex: 1;\n  overflow-y: ", ";\n  padding: ",
    ";\n  position: relative;\n"])), Color.WHITE, function (_a) {
    var isScrollable = _a.isScrollable;
    return (isScrollable ? 'auto' : 'hidden');
}, function (_a) {
    var isScrollable = _a.isScrollable;
    return isScrollable ? '32px 28px' : '32px 28px 0 28px';
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
//# sourceMappingURL=modal.js.map